import React from 'react';
import { Grid } from '@mui/material';

const commonStyles = {
  color: 'white',
  borderRadius: '5px',
  fontWeight: '400',
  textAlign: 'center',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '3px 12px',
  width: 'fit-content',
  height: 'fit-content',
  whiteSpace: 'nowrap',
  lineHeight: 1,
  zIndex: 10,
};

const getResponsiveFontSize = (matches450, matchesB) => {
  if (matches450) return '10px';
  if (matchesB) return '12px';
  return '14px';
};

export const Stage1 = ({
  matches450,
  matchesB,
  customStyles = {},
  ...props
}) => {
  const fontSize = getResponsiveFontSize(matches450, matchesB);

  return (
    <Grid
      item
      sx={{
        ...commonStyles,
        backgroundColor: '#10D35E',
        fontSize,
        ...customStyles,
      }}
      {...props}
    >
      STAGE 1
    </Grid>
  );
};

export const Stage2 = ({
  matches450,
  matchesB,
  customStyles = {},
  ...props
}) => {
  const fontSize = getResponsiveFontSize(matches450, matchesB);

  return (
    <Grid
      item
      sx={{
        ...commonStyles,
        backgroundColor: '#F93939',
        fontSize,
        ...customStyles,
      }}
      {...props}
    >
      STAGE 2
    </Grid>
  );
};

export const Stage2Final = ({
  matches450,
  matchesB,
  customStyles = {},
  ...props
}) => {
  const fontSize = getResponsiveFontSize(matches450, matchesB);

  return (
    <Grid
      item
      sx={{
        ...commonStyles,
        backgroundColor: '#F93939',
        fontSize,
        ...customStyles,
      }}
      {...props}
    >
      STAGE 2 - FINAL OFFERS
    </Grid>
  );
};

export const Ended = ({
  matches450,
  matchesB,
  customStyles = {},
  ...props
}) => {
  const fontSize = getResponsiveFontSize(matches450, matchesB);

  return (
    <Grid
      item
      sx={{
        ...commonStyles,
        backgroundColor: '#585858',
        fontSize,
        ...customStyles,
      }}
      {...props}
    >
      ENDED
    </Grid>
  );
};
